import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

import { useAuthStore } from '../stores/authStore';

/**
 * Redirect to `/login?return=<current-path>` if the user is not
 * authenticated. The `return` parameter lets LoginPage send the user
 * back to the page they were trying to reach.
 *
 * Returns the auth store's `isAuthenticated` flag so callers can render
 * `null` (or a skeleton) while the redirect is in flight.
 */
export function useAuthGuard(): { isAuthenticated: boolean } {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!isAuthenticated) {
      const returnPath = `${location.pathname}${location.search}`;
      navigate(`/login?return=${encodeURIComponent(returnPath)}`, { replace: true });
    }
  }, [isAuthenticated, location.pathname, location.search, navigate]);

  return { isAuthenticated };
}

export default useAuthGuard;
